/* eslint-disable jsx-a11y/accessible-emoji */
import React, { useState } from 'react';
import { Form as FinalForm, Field } from 'react-final-form';
import {
    Input, Button, Form, Container, Message, Label, Radio
} from 'semantic-ui-react';
import { getExtension } from '#/meta';
import { useCreateDocument, useUpdateDocument } from '~/documents';

const DocumentForm = props => {
    const [file, setFile] = useState(null);
    const [correctFileType, setCorrectFileType] = useState(false);
    const [showFileError, setShowFIleError] = useState(false);
    const { mutate: createDocument } = useCreateDocument();
    const { mutate: updateDocument } = useUpdateDocument();

    const checkFileType = (event, { value }) => {
        //make sure file is a docx file
        const ext = getExtension(value);
        if (ext === 'docx') {
            setCorrectFileType(true);
            setShowFIleError(false);
            setFile(event.target.files[0]);
        }
        else {
            setShowFIleError(true);
        }
    };
    const onSubmit = values => {

        if (props.initialValues) {
            updateDocument(values);
            props.setModalOpen(false);

            return;
        }
        const data = new FormData();
        data.append('file', file, file.name);
        data.append('name', file.name);
        data.append('description', values.description || '');
        data.append('requires_lawyer', values.requires_lawyer || false);
        data.append('requires_notary', values.requires_notary || false);

        createDocument(data);
        props.setModalOpen(false);
    };

    return (
        <Container>
            <FinalForm
                initialValues={props.initialValues}
                onSubmit={onSubmit}
                render={({ handleSubmit, submitting, pristine }) => (
                    <Form onSubmit={handleSubmit}>
                        <Form.Field>
                            <label htmlFor='description'>Name</label>
                            <Field name='description' component={Input} placeholder='Name' />
                        </Form.Field>
                        <Field name='requires_notary'>
                            {({ input, meta }) => (
                                <Form.Field>
                                    <label htmlFor='requires_notary'>Requires Notary Signature</label>
                                    <Radio
                                        toggle
                                        checked={input.value || false}
                                        onChange={(_, { checked }) => input.onChange(checked)}
                                    />
                                </Form.Field>
                            )}
                        </Field>
                        <Field name='requires_lawyer'>
                            {({ input, meta }) => (
                                <Form.Field>
                                    <label htmlFor='requires_lawyer'>Requires Lawyer Signature</label>
                                    <Radio
                                        toggle
                                        checked={input.value || false}
                                        onChange={(_, { checked }) => input.onChange(checked)}
                                    />
                                </Form.Field>
                            )}
                        </Field>

                        {!props.initialValues && (
                            <>
                                <Message error header='Incorrect file type' content='You can only upload .docx files' />
                                <Form.Field>
                                    <label htmlFor='file'>Select File</label>
                                    <Input type='file' onChange={checkFileType} />
                                    {showFileError && (
                                        <Label basic color='red' pointing>
                                            File type must be .docx
                                        </Label>
                                    )}
                                </Form.Field>
                            </>
                        )}

                        <Form.Field>
                            <Button
                                floated='left'
                                negative
                                style={{ margin: '10px' }}
                                onClick={() => props.setModalOpen(false)}
                            >
                                Cancel
                            </Button>
                            <Button
                                floated='right'
                                positive
                                type='submit'
                                disabled={submitting || pristine || (!correctFileType && !props.initialValues)}
                                style={{ margin: '10px' }}
                            >
                                Submit
                            </Button>
                        </Form.Field>
                    </Form>
                )}
            />
        </Container>
    );
};

export default DocumentForm;
